import dayjs from "dayjs"
import React, { useState } from "react"

const BookingSection = ({ bookableEvents, practice }) => {
  const [showAll, setShowAll] = useState(false)

  // Sort events by start time
  const sortedEvents = bookableEvents?.sort((a, b) => new Date(a.startsAt) - new Date(b.startsAt)) || []

  // Determine how many events to show
  const eventsToShow = showAll ? sortedEvents : sortedEvents.slice(0, 6)
  const shouldShowToggle = sortedEvents.length > 6

  const handleBooking = (event) => {
    const practiceId = practice.id
    window.location.href = `/checkout?pid=${practiceId}&beid=${event.id}`
  }

  const toggleShowAll = () => {
    setShowAll(!showAll)
  }

  const formatDateBlock = (date) => {
    const dayObj = dayjs(date)
    return {
      month: dayObj.format("MMM").toUpperCase(),
      day: dayObj.format("D")
    }
  }

  const formatEventDetails = (event, isMobile = false) => {
    const dayObj = dayjs(event.startsAt)
    const dateFormat = isMobile ? "ddd, MMM D, YYYY" : "dddd, MMM D, YYYY"
    const formattedDate = dayObj.format(dateFormat)

    if (event.allDay) {
      return {
        date: formattedDate,
        time: "All day"
      }
    }

    const startTime = dayObj.format("h:mma").toLowerCase()
    const endTime = dayjs(event.endsAt).format("h:mma").toLowerCase()
    return {
      date: formattedDate,
      time: `${startTime} - ${endTime}`
    }
  }

  if (!bookableEvents?.length) {
    return (
      <div className="mt-12">
        <div className="rounded-lg border border-gray-light bg-gray-ultralight p-6 text-center">
          <p className="text-gray">No available events at this time.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="mt-12">
      <h3
        className="mb-6 text-2xl font-bold"
        style={{ color: practice.theme.colorTextDark, fontFamily: practice.theme.fontHeading }}>
        Book Now
      </h3>

      <div className="space-y-4">
        {eventsToShow.map((event) => {
          const dateBlock = formatDateBlock(event.startsAt)
          const eventDetails = formatEventDetails(event)

          return (
            <div
              key={event.id}
              className="flex items-center justify-between rounded-xl p-6"
              style={{ backgroundColor: practice.theme.colorGreyLightest }}>
              {/* Desktop Layout */}
              <div className="flex items-center gap-4">
                {/* Date Block */}
                <div
                  className="flex h-20 min-h-20 min-w-16 flex-col items-center justify-center gap-0.5 rounded-lg border px-4 py-3 md:hidden"
                  style={{ backgroundColor: practice.theme.colorWhite, borderColor: practice.theme.colorGreyLight }}>
                  <div
                    className="text-center text-sm font-semibold leading-tight"
                    style={{ color: practice.theme.colorTextDark }}>
                    {dateBlock.month}
                  </div>
                  <div
                    className="text-center text-3xl font-semibold leading-10"
                    style={{ color: practice.theme.colorTextDark }}>
                    {dateBlock.day}
                  </div>
                </div>

                {/* Event Details */}
                <div className="flex flex-col gap-1">
                  <div className="text-lg font-semibold leading-normal" style={{ color: practice.theme.colorTextDark }}>
                    {eventDetails.date}
                  </div>
                  <div className="text-base font-normal leading-normal" style={{ color: practice.theme.colorTextDark }}>
                    {eventDetails.time}
                  </div>
                </div>
              </div>

              {/* Booking Button and Spots */}
              <div className="flex flex-col items-center justify-center gap-2">
                <button
                  onClick={() => handleBooking(event)}
                  className="rounded px-10 py-3 font-medium leading-normal transition-colors hover:opacity-90 "
                  style={{
                    backgroundColor: practice.theme.colorAccent,
                    color: practice.theme.colorTextLight
                  }}>
                  Book
                </button>
                {event.spotsAvailable > 0 && (
                  <div
                    className="text-center text-sm font-normal leading-tight "
                    style={{ color: practice.theme.colorAccent }}>
                    {event.spotsAvailable} {event.spotsAvailable === 1 ? "spot" : "spots"} left
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {/* Show More/Less Toggle */}
      {shouldShowToggle && (
        <div className="mt-6">
          <button
            onClick={toggleShowAll}
            className="text-sm font-semibold underline transition-colors duration-150 hover:opacity-75"
            style={{ color: practice.theme.colorAccent }}>
            {showAll
              ? "Show less"
              : `Show more (${sortedEvents.length - 6} more event${sortedEvents.length - 6 === 1 ? "" : "s"})`}
          </button>
        </div>
      )}
    </div>
  )
}

export default BookingSection
